@if (info) {
  <div id="boton-home-{{info.ref}}" class="fadein portada-linea-inversion d-none d-lg-block h-100">
      <div class="pointer linea-box p-4 px-lg-3 px-xl-4 h-100 d-flex align-items-center {{isActive ? info.segoBgActive : 'bg-default'}}"
        title="{{info.segoTitulo}}">
        <div class="d-flex align-items-center">
          <div class="circle-container-50 d-flex justify-content-center align-items-center {{isActive ? 'bg-primary-50' : 'bg-' + info.lineaColorActive}}">
            <span class="material-symbols-outlined mat-icon-size-30 {{isActive ? info.lineaColorActive : 'primary-50'}}">{{info.segoMatIconName}}</span>
          </div>
          <div class="ms-3">
            <p class="linea-title font-primary letter-spacing-4 primary-900 font-lg-fix mb-0">{{info.segoTitulo}}</p>
            <p class="linea-subtitle neutral-900 font-lg-fix mb-0" [innerHtml]="info.segoInvertir"></p>
          </div>
        </div>
      </div>
  </div>
}